// extracted by mini-css-extract-plugin
export default {"noBtn":"YesNoAnswer_noBtn__THBK1"};